<template>
  <div
    class="calendar-time-line"
    :style="{
      'top': nowPos + 'px'
    }"
  >
    <div class="calendar-time-line-label">{{ now }}</div>
    <div class="calendar-time-line-border"></div>
  </div>
</template>
<script>
export default {
  name: 'CalendarTimeLine',
  props: {},
  data () {
    return {
      nowPos: 0,
      now: '',
      left: 0
    }
  },
  mounted () {
    this.getCurrLine()
    this.updateLinePosition()
  },
  methods: {
    getCurrLine () {
      this.now = moment().format('HH:mm')
      this.nowPos = moment().diff(moment().startOf('day'), 'minute')
    },
    updateLinePosition () {
      clearTimeout(this.timer)
      this.getCurrLine()
      this.timer = setTimeout(() => {
        this.updateLinePosition()
      }, 1000 * 60)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>
<style lang="stylus">
.calendar-time-line
  position absolute
  left 0
  right 18px
  display flex
  align-items center
  z-index 9
  &-label
    color #ed6c00
    font-size .75rem
  &-border
    flex 1
    margin-left 20px
    border-top 1px solid #ed6c00
</style>
